export default function ClarityScript(consent = null) {
  if (!process.env.REACT_APP_IS_PRODUCTION) return;
  if (document.getElementById('clarity-script')) return;

  const clarity = document.createElement('script');
  clarity.id = 'clarity-script';
  clarity.type = 'text/javascript';
  clarity.async = true;
  clarity.textContent = `
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "sqib17ga3p");
  `;
  
  console.log('Clarity script loaded');
  document.head.appendChild(clarity);

  try {
    if (!consent) return;
    window.clarity('consentv2', consent);
    console.log('Consent sent to Clarity:', consent);
  } catch (error) {
    console.error('Failed to send consent to Clarity:', error);
  }
};
